import { useTranslation } from "react-i18next";

type SettingsInfoChipsProps = {
  userLoading: boolean;
  resolvedUserCode: string | null;
  userError: unknown;
  resolvedRoleLabel: string;
};

export default function SettingsInfoChips({
  userLoading,
  resolvedUserCode,
  userError,
  resolvedRoleLabel,
}: SettingsInfoChipsProps) {
  const { t } = useTranslation(["pages.settings"]);

  return (
    <aside className="w-[200px] min-w-[200px] space-y-2">
      <div className="w-[200px] rounded-full border border-black bg-white px-4 py-2 shadow-[0_1px_2px_rgba(0,0,0,0.08)]">
        <div className="text-[10px] leading-none text-[#666666]">
          {t("pages.settings:sections.profile.fields.userId")}
        </div>
        <div className="mt-1 truncate text-xs font-semibold text-black">
          {userLoading ? "..." : resolvedUserCode || "-"}
        </div>
      </div>
      <div className="w-[200px] rounded-full border border-black bg-white px-4 py-2 shadow-[0_1px_2px_rgba(0,0,0,0.08)]">
        <div className="text-[10px] leading-none text-[#666666]">
          {t("pages.settings:sections.members.table.role")}
        </div>
        <div className="mt-1 truncate text-xs font-semibold text-black">
          {userError
            ? t("pages.settings:sections.profile.roles.unknown")
            : resolvedRoleLabel}
        </div>
      </div>
    </aside>
  );
}
